import { render, staticRenderFns } from "./WidgetDemo.vue?vue&type=template&id=406f8a33&scoped=true&"
import script from "./WidgetDemo.vue?vue&type=script&lang=js&"
export * from "./WidgetDemo.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDemo.vue?vue&type=style&index=0&id=406f8a33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f8a33",
  null
  
)

export default component.exports